var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-component"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('a', {
    staticClass: "footer-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.scrollTop
    }
  }, [_vm._v("Наверх")])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "copyright"
  }, [_vm._v("2017. Сноуборды Phantom Equipment."), _c('br'), _vm._v("Все права защищены.")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "footer-link-vk",
    attrs: {
      "href": "https://vk.com/phantom.equipment"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/vk.jpg"),
      "width": "45",
      "height": "45"
    }
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a994d624","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/footerComponent.vue
// module id = OGbF
// module chunks = 0